import './featured-image-text.css';

export default () => {

};
